import { Reveal } from "./Reveal";
import { SERVICES, SECONDARY } from "./data";
import { ArrowUpRight } from "lucide-react";

function ServiceCard({ service, delay }) {
  return (
    <Reveal className={service.span} delay={delay}>
      <article
        data-testid={`service-${service.id}`}
        className="group relative h-[560px] overflow-hidden border border-white/10"
      >
        <img
          src={service.image}
          alt={service.title}
          className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/45 to-transparent" />
        <div className="relative h-full flex flex-col justify-end p-8 lg:p-12">
          <p className="overline mb-4">{service.tagline}</p>
          <h3 className="font-heading text-3xl lg:text-4xl font-medium tracking-tight">{service.title}</h3>
          <p className="mt-4 max-w-lg font-light leading-relaxed text-foreground/75">{service.body}</p>
          <div className="mt-6 flex flex-wrap gap-x-6 gap-y-2">
            {service.points.map((p) => (
              <span key={p} className="text-sm text-foreground/60 flex items-center gap-2">
                <span className="h-1 w-1 rounded-full bg-gold" />
                {p}
              </span>
            ))}
          </div>
          <a
            href="#contact"
            data-testid={`service-${service.id}-link`}
            className="mt-7 inline-flex items-center gap-2 text-sm text-gold hover:gap-3 transition-all duration-300"
          >
            Enquire privately <ArrowUpRight size={16} />
          </a>
        </div>
      </article>
    </Reveal>
  );
}

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="relative py-28 lg:py-40 border-t border-white/5">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="max-w-2xl mb-16">
          <Reveal>
            <p className="overline mb-6">What We Do</p>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-heading font-light text-4xl sm:text-5xl lg:text-6xl leading-tight tracking-tight">
              Three disciplines at our core. One standard of excellence.
            </h2>
          </Reveal>
        </div>

        <div className="grid lg:grid-cols-12 gap-6">
          {SERVICES.map((s, i) => (
            <ServiceCard key={s.id} service={s} delay={i * 0.1} />
          ))}
        </div>

        {/* Secondary offerings */}
        <div className="mt-20">
          <Reveal>
            <p className="overline mb-8">Also Offering</p>
          </Reveal>
          <div className="grid sm:grid-cols-2 gap-px bg-white/10 border border-white/10">
            {SECONDARY.map((s, i) => (
              <Reveal key={s.id} delay={i * 0.1} className="bg-background">
                <div data-testid={`secondary-${s.id}`} className="h-full p-8 lg:p-10">
                  <h3 className="font-heading text-2xl lg:text-3xl font-medium tracking-tight">{s.title}</h3>
                  <p className="mt-3 font-light leading-relaxed text-foreground/60">{s.body}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
